@if (rendererTemplate()) {
  <div class="template" [innerHTML]="rendererTemplate()"></div>
}
